/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyTaskItemDto
 */
export interface DailyTaskItemDto {
    /**
     * 
     * @type {string}
     * @memberof DailyTaskItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskItemDto
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof DailyTaskItemDto
     */
    points: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyTaskItemDto
     */
    isCompleted: boolean;
    /**
     * 
     * @type {object}
     * @memberof DailyTaskItemDto
     */
    completedAt?: object | null;
}

/**
 * Check if a given object implements the DailyTaskItemDto interface.
 */
export function instanceOfDailyTaskItemDto(value: object): value is DailyTaskItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    return true;
}

export function DailyTaskItemDtoFromJSON(json: any): DailyTaskItemDto {
    return DailyTaskItemDtoFromJSONTyped(json, false);
}

export function DailyTaskItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyTaskItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'points': json['points'],
        'isCompleted': json['isCompleted'],
        'completedAt': json['completedAt'] == null ? undefined : json['completedAt'],
    };
}

export function DailyTaskItemDtoToJSON(json: any): DailyTaskItemDto {
    return DailyTaskItemDtoToJSONTyped(json, false);
}

export function DailyTaskItemDtoToJSONTyped(value?: DailyTaskItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'points': value['points'],
        'isCompleted': value['isCompleted'],
        'completedAt': value['completedAt'],
    };
}

